import { read, update } from '@/api/rest';

const checkpointCompetenceSet = {
  index: async (params) =>
    await read('/checkpoint-competence-set?' + params.toString()),
  performerCompetencies: async (params) =>
    await read(
      '/checkpoint-competence-set/performer-competencies?' + params.toString()
    ),
  hasUnconfirmedCompetencies: async () =>
    await read('/checkpoint-competence-set/has-unconfirmed-competencies'),
  saveCheckpointCompetencies: async (data) =>
    await update(
      '/checkpoint-competence-set/save-checkpoint-competencies',
      data
    ),
};
export default checkpointCompetenceSet;
